module.exports = __webpack_public_path__ + "img/画板 1 拷贝 23.6f7195b2.jpg";